var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.href)?_c('router-link',{attrs:{"to":_vm.user && _vm.user.id ? `/u/${_vm.user.id}` : '/u/0'}},[_c('el-avatar',{attrs:{"shape":_vm.shape,"size":_vm.size,"fit":"fill","src":_vm.user && _vm.user.avatar
          ? _vm.url + _vm.user.avatar
          : 'https://www.wch.cn/uploads/avatar/head.gif'}})],1):_c('el-avatar',{attrs:{"shape":_vm.shape,"size":_vm.size,"fit":"fill","src":_vm.user && _vm.user.avatar
        ? _vm.url + _vm.user.avatar
        : 'https://www.wch.cn/uploads/avatar/head.gif'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }